<p-stepper
  [value]="stepCurrent()"
  [linear]="linear()"
  class="basis-[50rem] stepper-custom">
  <p-step-list>
    <p-step
      *ngFor="let step of steps()"
      [value]="step.value"
      class="text-neutral-dark"
      (click)="onStepChange(step.value)"
      [disabled]="isStepDisabled(step.value)">
      {{ step.label }}
    </p-step>
  </p-step-list>
</p-stepper>
